(function () {
  'use strict';

  const page = (window.FoxTheme && window.FoxTheme.page) || {};

  const RecentlyViewed = {
    storageKey: 'coracrea_recently_viewed',
    maxItems: 8,

    // Track current product
    trackProduct: function () {
      if (page.product) {
        const product = {
          id: page.product.id,
          handle: page.product.handle,
          title: page.product.title,
          url: page.product.url,
          image: page.product.featuredImage || null,
          price: page.product.price,
          available: page.product.available,
        };

        this.addProduct(product);
      }
    },

    // Add product to localStorage
    addProduct: function (product) {
      let products = this.getProducts();

      // Remove if already exists (to move to front)
      products = products.filter((p) => p.id !== product.id);

      // Add to front
      products.unshift(product);

      // Keep only max items
      if (products.length > this.maxItems) {
        products = products.slice(0, this.maxItems);
      }

      localStorage.setItem(this.storageKey, JSON.stringify(products));
    },

    // Get products from localStorage
    getProducts: function () {
      try {
        const stored = localStorage.getItem(this.storageKey);
        return stored ? JSON.parse(stored) : [];
      } catch {
        return [];
      }
    },

    // Display recently viewed products
    displayProducts: function () {
      const products = this.getProducts();

      const filtered = page.product ? products.filter((p) => p.id !== page.product.id) : products;

      if (filtered.length === 0) {
        return; // No products to show
      }

      const container = document.getElementById('recently-viewed-grid');
      const section = document.getElementById('recently-viewed-products');

      if (!container || !section) return;

      while (container.firstChild) container.removeChild(container.firstChild);

      // Show up to 4 products
      filtered.slice(0, 4).forEach((product) => {
        const item = document.createElement('a');
        item.href = product.url;
        item.className = 'recently-viewed-item';

        if (product.image) {
          const img = document.createElement('img');
          img.src = product.image;
          img.alt = product.title || '';
          img.loading = 'lazy';
          item.appendChild(img);
        }
        const info = document.createElement('div');
        info.className = 'recently-viewed-item-info';
        const rvTitle = document.createElement('h3');
        rvTitle.className = 'recently-viewed-item-title';
        rvTitle.textContent = product.title || '';
        info.appendChild(rvTitle);
        const rvPrice = document.createElement('p');
        rvPrice.className = 'recently-viewed-item-price';
        rvPrice.textContent = product.price || '';
        info.appendChild(rvPrice);
        item.appendChild(info);

        container.appendChild(item);
      });

      // Show section
      section.style.display = 'block';
      section.classList.add('loaded');
    },

    // Initialize
    init: function () {
      // Track current product (if on product page)
      this.trackProduct();

      // Display recently viewed (on all pages except current product)
      setTimeout(() => {
        this.displayProducts();
      }, 100);
    },
  };

  // Initialize when DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => RecentlyViewed.init());
  } else {
    RecentlyViewed.init();
  }

  // Make available globally
  window.RecentlyViewed = RecentlyViewed;
})();
